<template>
  <b-overlay
    id="overlay-background"
    :show="rightLoader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-alert
      v-if="btnCliked"
      variant="primary"
      show
    >
      <!-- body -->
      <b-card-body
        v-if="currentModules.length > 0"
      >
        <!-- types -->
        <inner-modules-list
          :modules-object="currentModules"
          :module-object-id="actionId"
          :main-div-id="mainDivId"
        />
      </b-card-body>
      <b-card-body
        v-else
      >
        <!-- types -->
        <app-collapse
          accordion
          :type="collapseType"
        >
          <b-list-group
            class="reminder-fee-item"
          >
            <b-list-group-item>
              {{ $t('DEBTIA_NO_BUTTON_MODULES') }}</b-list-group-item>
          </b-list-group>
        </app-collapse>
      </b-card-body>
    </b-alert>
    <b-alert
      v-else
      variant="primary"
      show
    >
      <b-card
        border-variant="primary"
        bg-variant="transparent"
        class="shadow-none align-items-center"
      >
        <b-card-text>
          {{ $t('DEBTIA_NO_BUTTON_CLICKED') }}
        </b-card-text>
      </b-card>
    </b-alert>
  </b-overlay>
</template>

<script>
import {
  BOverlay, BAlert, BCardBody, BListGroup, BListGroupItem, BCard, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
// import i18n from '@/libs/i18n'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import InnerModulesList from './InnerModulesList.vue'
// import AddModuleModal from './AddModuleModal.vue'

export default {
  components: {
    BOverlay,
    BAlert,
    AppCollapse,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BCard,
    BCardText,
    InnerModulesList,
  },
  directives: {
    Ripple,
  },
  props: {
    buttonModules: {
      type: Array,
      required: true,
    },
    moduleId: {
      type: Number,
      required: true,
    },
    actionId: {
      type: Number,
      required: true,
    },
    parentId: {
      type: Number,
      required: true,
    },
    activeButtonId: {
      type: Number,
      required: true,
    },
    mainDivId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userType: JSON.parse(localStorage.getItem('userData')).role[0],
      btnCliked: false,
      collapseType: 'margin',
      rightLoader: false,
      btnID: 0,
      btn_title: '',
      currentModules: [],
      conditionOptions: [
        { label: 'Is the debtor our former client?', value: 1 },
        { label: 'Is the case approved?', value: 2 },
      ],
    }
  },
  watch: {
    buttonModules: {
      handler() {
        // console.log('actionId ', this.actionId)
        // console.log('this.activeButtonId ', this.activeButtonId)
        // console.log('this.buttonModules ', this.buttonModules)
        this.currentModules = this.buttonModules.filter(element => element.condition === this.activeButtonId)
      },
    },
    refresh: {
      handler() {
        this.refreshmodules()
      },
    },
  },
  created() {
    EventBus.$on('getBtnIdModules', obj => {
      if (this.moduleId === obj.moduleId) {
        this.printModules(obj.btnID, obj.btn_title)
      }
    })
  },
  methods: {
    refreshmodules() {
      this.rightLoader = true
      const processID = this.$route.params.id
      const url = `/process/get/${processID}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          // console.log('btn refreshed response', response)
          const arr = response.data.data.process_modules.filter(element => element.condition === this.refreshBtn)
          this.currentModules = arr
          this.rightLoader = false
        }
      })
    },
    addButtonModule(btnID) {
      const obj = {
        parentID: this.parentId,
        moduleID: this.moduleId,
        type: btnID,
      }
      EventBus.$emit('addModuleInButton', obj)
      // this.$emit('addChildModule', obj)
    },
    printModules(btnID, title) {
      const arr = this.buttonModules.filter(element => element.condition === btnID)
      this.rightLoader = true
      setTimeout(() => {
        this.currentModules = arr
        this.rightLoader = false
        this.btnCliked = true
        this.btn_title = title
        this.btnID = btnID
      }, 1500)
    },
    getConditionStatement(id) {
      const conditionTitle = this.conditionOptions.filter(element => element.value === id)
      return conditionTitle[0].label
    },
  },
}
</script>

<style lang="scss">
.btn-list {
    margin-bottom: 10px;
}
.left-side{
    padding:20px;
}
.details-header {
    border-bottom: 1px solid #ffffff !important;
    margin-bottom: 20px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
.reminder-fee-item {
  margin-top: 11px;
}
</style>
